import React, { useState, useEffect } from 'react';
import { Link } from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

/**
 *
 * @param {*} props
 * @returns
 */
function SponsorsRow(props) {
  const [sponsor, setSponsor] = useState({});
  // const subTableRowStyle = { fontSize: "1.7rem", color: "white" };

  useEffect(() => {
    setSponsor(props.c);
    //setDeleteCallBack(props.deleteCallBack);
  }, []);

  return (
    <>
      <TableRow
        key={sponsor.id}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell
          style={{ color: 'white', fontSize: '1.5rem' }}
          component='th'
          scope='row'
        >
          {sponsor.name}
        </TableCell>
        <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
          {sponsor.webSite}
        </TableCell>
        <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
          {sponsor.order}
        </TableCell>
        <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
          {sponsor.active ? 'Activo' : 'Inactivo'}
        </TableCell>
        <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
          {sponsor.contents?.length}
        </TableCell>
        <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
          <Link href={`/admin/panel/sp/${sponsor.id}/edit`}>
            <EditIcon color='primary' />
          </Link>
        </TableCell>
        <TableCell style={{ color: 'white', fontSize: '1.5rem' }}>
          <DeleteIcon
            style={{ cursor: 'pointer' }}
            onClick={() => props.deleteCallBack(sponsor.id)}
            color='primary'
          />
        </TableCell>
      </TableRow>
    </>
  );
}

export default SponsorsRow;
